module.exports = __webpack_public_path__ + "static/media/filter-equipment.17b1fa97.svg";